import { TThunkAction } from '../../types/redux';

/** Возвращает поле user.isAgent из стора, когда это не получается делать с помощью useSelector */
export const checkIsAgent = (): TThunkAction<boolean | null> => (dispatch, getState) => {
  const {
    user: { isAgent },
  } = getState();

  return isAgent || null;
};
